module.exports = __webpack_public_path__ + "img/png3.7585981f.png";